import { api } from "../../../api/Middleware";
import { ACCOUNT_URL, USERS_URL, ACCOUNT_FEATURES_URL } from "../../../api/Urls";

// Listar todos os usuários
export const listUsers = async (params = {}) => {
  return await api.get(USERS_URL, { params });
};

// Buscar usuário específico
export const getUser = async (id) => {
  return await api.get(USERS_URL + `${id}/`);
};

// Criar novo usuário (método seguro)
export const createUserSecure = async (data) => {
  return await api.post(USERS_URL + "create_user_secure/", data);
};

// Atualizar usuário existente
export const updateUser = async (id, data) => {
  return await api.put(USERS_URL + `${id}/`, data);
};

// Atualizar parcialmente usuário
export const patchUser = async (id, data) => {
  return await api.patch(USERS_URL + `${id}/`, data);
};

// Deletar usuário (inativar)
export const deleteUser = async (id) => {
  return await api.delete(USERS_URL + `${id}/`);
};

export const validateCPF = async (data) => {
  try {
    let response = await api.post(USERS_URL + "validate_cpf/", data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error.response;
  }
};

// Quick Signup - Cadastro rápido de conta e usuário
export const quickSignup = async (data) => {
  try {
    const response = await api.post(ACCOUNT_URL+ "quick-signup/", data);
    return response;
  } catch (error) {
    console.error("Erro no quick signup:", error);
    throw error;
  }
};

// Signup pago — step 1: cobra no Asaas, cria CustomerPayments sem Account
export const signupPayment = async (data) => {
  try {
    const response = await api.post(ACCOUNT_URL + "signup/payment/", data);
    return response;
  } catch (error) {
    console.error("Erro no signup payment:", error);
    throw error;
  }
};

// Signup pago — step 2: finaliza cadastro após pagamento confirmado
export const signupFinalize = async (data) => {
  try {
    const response = await api.post(ACCOUNT_URL + "signup/finalize/", data);
    return response;
  } catch (error) {
    console.error("Erro no signup finalize:", error);
    throw error;
  }
};

// Onboarding - Salvar respostas do questionário pós-signup
export const postOnboarding = async (accountId, payload) => {
  try {
    const response = await api.post(
      `${ACCOUNT_URL}${accountId}/onboarding/`,
      payload
    );
    return response;
  } catch (error) {
    console.error("Erro ao salvar onboarding:", error);
    throw error;
  }
};

// Listar superusuários da conta
export const getSuperUsers = async () => {
  return await api.get(USERS_URL + "get_superusers/");
};

// Atualizar permissão específica do usuário (NOVO - usando feature_id)
export const updateUserPermission = async (userId, permissionData) => {
  // Se permissionData tem feature_id, usar novo endpoint
  if (permissionData.feature_id) {
    return await api.post(
      USERS_URL + `${userId}/update_user_feature_permission/`,
      permissionData
    );
  }
  
  // Fallback para endpoint antigo (compatibilidade)
  return await api.post(
    USERS_URL + `${userId}/update_user_permission/`,
    permissionData
  );
};

// Atualizar permissão por feature ID (método específico)
export const updateUserFeaturePermission = async (userId, permissionData) => {
  return await api.post(
    USERS_URL + `${userId}/update_user_feature_permission/`,
    permissionData
  );
};

// Resetar permissões do usuário para padrão do nível
export const resetUserPermissions = async (userId) => {
  return await api.post(USERS_URL + `${userId}/reset_user_permissions/`, {});
};

// Criar primeiro admin (método especial)
export const createFirstAdmin = async (data) => {
  return await api.post(USERS_URL + "create_first_admin/", data);
};

// Upload de foto de usuário
export const uploadUserPhoto = async (userId, photoFile) => {
  const formData = new FormData();
  formData.append("photo", photoFile);

  return await api.patch(USERS_URL + `${userId}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getUserPermissions = async () => {
  return await api.get(`${USERS_URL}get_user_permissions/`);
};

// Reenviar email de ativação de conta (apenas staff)
export const resendActivationEmail = async (accountId) => {
  try {
    const response = await api.post(`${ACCOUNT_URL}${accountId}/resend-activation-email/`);
    return response;
  } catch (error) {
    console.error("Erro ao reenviar email de ativação:", error);
    throw error;
  }
};

// Buscar features liberadas para a conta
export const getAccountFeatures = async () => {
  try {
    const response = await api.get(`${ACCOUNT_FEATURES_URL}?simple=1`);
    return response;
  } catch (error) {
    console.error("Erro ao buscar features da conta:", error);
    throw error;
  }
};
